module.exports = __webpack_public_path__ + "instagram-logo-grey.3527acb47ceac9f6ef8e.svg";


//////////////////
// WEBPACK FOOTER
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/assets/icons/instagram-logo-grey.svg
// module id = ../../../../../src/assets/icons/instagram-logo-grey.svg
// module chunks = main